import { render, staticRenderFns } from "./his-list.vue?vue&type=template&id=48d3a616&scoped=true"
import script from "./his-list.vue?vue&type=script&lang=js"
export * from "./his-list.vue?vue&type=script&lang=js"
import style0 from "./his-list.vue?vue&type=style&index=0&id=48d3a616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3a616",
  null
  
)

export default component.exports